import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer";
import AboutUs from "./Components/AboutUs";
import ChimneyRepairService from "./Components/Services/ChimneyRepairService";
import HobRepairService from "./Components/Services/HobRepairService";
import CooktopRepairService from "./Components/Services/CookTopRepairService";
import ElectricCooktopRepairService from "./Components/Services/GasStoveRepairService";
import OvenMicrowaveRepairService from "./Components/Services/OvenMicroWareRepairService";
import ContactUs from "./Components/ContactUs";
import CookingRangeService from "./Components/Services/CookingRangeService";
import GasStoveRepairService from "./Components/Services/GasStoveRepairService";
import GasServiceRepair from "./Components/Services/GasServiceRepair";
import SupportWidget from "./Components/SupportWidget";
import TherapySession from "./Components/TherapySession";
import Speciality from "./Components/Speciality";
import BookSessionForm from "./Components/BookSessionForm";
import ConfirmationPage from "./Components/ConfirmationPage";
import PrivacyNote from "./Components/PrivacyNote";
import ScrollToTop from "./Components/ScrollToTop";

const App = () => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/therapy-sessions" element={<TherapySession />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/specialty" element={<Speciality />} />
        <Route path="/book-session" element={<BookSessionForm />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/privacy-note" element={<PrivacyNote />} />
      </Routes>
      {/* <SupportWidget /> */}
      <Footer />
    </>
  );
};

export default App;
